export default __webpack_public_path__ + "static/media/reportnet_public_logo.7a276db0.svg";